import { ContactNode } from '@prezly/story-content-format';
import classNames from 'classnames';
import { Envelope, Facebook, Globe, Phone, Telephone, X } from "../../icons/index.mjs";
import { getMailtoHref, getSocialHandles, getTelHref, getUrl } from "./lib/index.mjs";
import { SocialField } from "./SocialField.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function SocialFields(_ref) {
  var {
    className,
    contact,
    layout
  } = _ref;
  var {
    email,
    phone,
    mobile
  } = contact;
  var website = getUrl(contact.website);
  var {
    facebook,
    twitter
  } = getSocialHandles(contact);
  if (layout === ContactNode.Layout.SIGNATURE) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs("ul", {
        className: classNames('prezly-slate-social-fields', 'prezly-slate-social-fields--signature', className),
        children: [email && /*#__PURE__*/_jsx(SocialField, {
          className: "prezly-slate-social-fields__field",
          href: getMailtoHref(email),
          children: "E. ".concat(email)
        }), phone && /*#__PURE__*/_jsx(SocialField, {
          className: "prezly-slate-social-fields__field",
          href: getTelHref(phone),
          children: "P. ".concat(phone)
        }), mobile && /*#__PURE__*/_jsx(SocialField, {
          className: "prezly-slate-social-fields__field",
          href: getTelHref(mobile),
          children: "M. ".concat(mobile)
        }), website && /*#__PURE__*/_jsx(SocialField, {
          className: "prezly-slate-social-fields__field",
          href: website.toString(),
          children: "W. ".concat(website.hostname)
        })]
      }), /*#__PURE__*/_jsxs("ul", {
        className: classNames('prezly-slate-social-fields', 'prezly-slate-social-fields--signature', 'prezly-slate-social-fields--icons', className),
        children: [facebook && /*#__PURE__*/_jsx(SocialField, {
          className: "prezly-slate-social-fields__field",
          href: "https://www.facebook.com/".concat(facebook),
          Icon: Facebook
        }), twitter && /*#__PURE__*/_jsx(SocialField, {
          className: "prezly-slate-social-fields__field",
          href: "https://twitter.com/".concat(twitter),
          Icon: X
        })]
      })]
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("ul", {
      className: classNames('prezly-slate-social-fields', 'prezly-slate-social-fields--card', className),
      children: [email && /*#__PURE__*/_jsx(SocialField, {
        className: "prezly-slate-social-fields__field",
        href: getMailtoHref(email),
        Icon: Envelope,
        children: email
      }), phone && /*#__PURE__*/_jsx(SocialField, {
        className: "prezly-slate-social-fields__field",
        href: getTelHref(phone),
        Icon: Telephone,
        children: phone
      }), mobile && /*#__PURE__*/_jsx(SocialField, {
        className: "prezly-slate-social-fields__field",
        href: getTelHref(mobile),
        Icon: Phone,
        children: mobile
      })]
    }), /*#__PURE__*/_jsxs("ul", {
      className: classNames('prezly-slate-social-fields', 'prezly-slate-social-fields--card', className),
      children: [website && /*#__PURE__*/_jsx(SocialField, {
        className: "prezly-slate-social-fields__field",
        href: website.toString(),
        Icon: Globe,
        children: website.hostname
      }), facebook && /*#__PURE__*/_jsx(SocialField, {
        className: "prezly-slate-social-fields__field",
        href: "https://www.facebook.com/".concat(facebook),
        Icon: Facebook,
        children: facebook
      }), twitter && /*#__PURE__*/_jsx(SocialField, {
        className: "prezly-slate-social-fields__field",
        href: "https://twitter.com/".concat(twitter),
        Icon: X,
        children: "@".concat(twitter)
      })]
    })]
  });
}